/**
 * The melody editor's shortcuts, as the shortcut help lists them (melody toolkit M2; spec §10). The letters
 * work while the roll has focus; Alt+← / → while a chord in the lane has focus. The user approved the copy
 * on 2026-10-24.
 */
export const melodyShortcuts = [
  { key: 'Space', description: 'Play or stop' },
  { key: 'L', description: 'Loop on or off' },
  { key: 'C', description: 'Chords on or off' },
  { key: 'M', description: 'Melody on or off' },
  { key: 'R', description: 'Sing an idea' },
  { key: 'Alt+← / →', description: 'Move the end of a chord by a beat' },
  { key: 'Esc', description: 'Leave the roll' },
] as const
